(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["implicit-bestsellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('implicit-bestsellers')) {
    class ImplicitBestsellers extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ibs-track]');

        if (!this.track) return;

        this.prevButtons = Array.from(
          this.querySelectorAll('[data-ibs-prev]')
        );

        this.nextButtons = Array.from(
          this.querySelectorAll('[data-ibs-next]')
        );

        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.handleScroll = () => this.requestUpdate();
        this.handleBlockSelect = (event) => {
          const target = event.target;

          if (
            target instanceof Element &&
            target.matches('[data-ibs-card]')
          ) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          }
        };

        this.prevButtons.forEach((button) => {
          button.addEventListener('click', this.handlePrevious);
        });

        this.nextButtons.forEach((button) => {
          button.addEventListener('click', this.handleNext);
        });

        this.track.addEventListener(
          'scroll',
          this.handleScroll,
          { passive: true }
        );

        this.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect
        );

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            this.updateButtons();
          });

          this.resizeObserver.observe(this.track);
        }

        requestAnimationFrame(() => {
          this.updateButtons();
        });
      }

      disconnectedCallback() {
        this.prevButtons?.forEach((button) => {
          button.removeEventListener(
            'click',
            this.handlePrevious
          );
        });

        this.nextButtons?.forEach((button) => {
          button.removeEventListener(
            'click',
            this.handleNext
          );
        });

        this.track?.removeEventListener(
          'scroll',
          this.handleScroll
        );

        this.removeEventListener(
          'shopify:block:select',
          this.handleBlockSelect
        );

        this.resizeObserver?.disconnect();

        if (this.updateFrame) {
          cancelAnimationFrame(this.updateFrame);
        }
      }

      move(direction) {
        const firstCard =
          this.track.querySelector('[data-ibs-card]');

        if (!firstCard) return;

        const trackStyles = getComputedStyle(this.track);

        const gap =
          parseFloat(trackStyles.columnGap) ||
          parseFloat(trackStyles.gap) ||
          0;

        const distance =
          firstCard.getBoundingClientRect().width + gap;

        const reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.track.scrollBy({
          left: direction * distance,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      requestUpdate() {
        if (this.updateFrame) return;

        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = null;
          this.updateButtons();
        });
      }

      updateButtons() {
        if (!this.track) return;

        const maxScroll =
          this.track.scrollWidth - this.track.clientWidth;

        const currentScroll = this.track.scrollLeft;

        const hasOverflow = maxScroll > 2;

        const atStart =
          !hasOverflow || currentScroll <= 2;

        const atEnd =
          !hasOverflow ||
          currentScroll >= maxScroll - 2;

        this.prevButtons?.forEach((button) => {
          button.disabled = atStart;
        });

        this.nextButtons?.forEach((button) => {
          button.disabled = atEnd;
        });
      }
    }

    customElements.define(
      'implicit-bestsellers',
      ImplicitBestsellers
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
